// Copyright (c) 2016 Deere & Company

import WarrantyExpiration from '../../../reports/warranty-expiration/state-connector';

export default {
    component: WarrantyExpiration,
    name: 'WARRANTY_EXPIRATION',
    path: 'warranty-expiration'
};




// WEBPACK FOOTER //
// ./src/routes/products/reports/warranty-expiration.js